import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

const STEPS = [
    {
        n: "01",
        title: "Drop in a clip",
        body: "Film anything on your phone, or start with one of our sample clips. Portrait, square or landscape.",
    },
    {
        n: "02",
        title: "Tap a look",
        body: "Scroll the filter wall, drag the intensity until it feels right, fine-tune with the dials if you like.",
    },
    {
        n: "03",
        title: "Export & share",
        body: "One tap renders the finished video right on your phone. Download it and post it everywhere.",
    },
];

export default function Steps() {
    return (
        <section id="how" className="border-t border-white/10 bg-surface/40 py-20 sm:py-28 lg:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <motion.div {...fadeUp} className="max-w-2xl">
                    <p className="mb-4 font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-amberx">
                        How it works
                    </p>
                    <h2 className="font-display text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">
                        Three taps from camera to feed.
                    </h2>
                </motion.div>

                <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8">
                    {STEPS.map((s, i) => (
                        <motion.div
                            key={s.n}
                            {...fadeUp}
                            transition={{ ...fadeUp.transition, delay: i * 0.1 }}
                            className="relative border-t-2 border-white/15 pt-6"
                        >
                            <span className="font-mono text-sm font-bold tracking-[0.25em] text-amberx">
                                {s.n}
                            </span>
                            <h3 className="mt-4 font-display text-2xl font-bold sm:text-3xl">{s.title}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">{s.body}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
